import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/icon.png'
import _imports_1 from '../assets/success.png'
import _imports_2 from '../assets/warn.png'
import _imports_3 from '../assets/error.png'


const _withScopeId = n => (_pushScopeId("data-v-84d6d1d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "icon"
}, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "info"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  src: _imports_1,
  alt: ""
}
const _hoisted_7 = {
  key: 1,
  src: _imports_2,
  alt: ""
}
const _hoisted_8 = {
  key: 2,
  src: _imports_3,
  alt: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.ifshow)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.info.avatar)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("img", {
                src: _ctx.info.avatar,
                alt: "",
                class: "avatar"
              }, null, 8, _hoisted_4),
              _createElementVNode("p", null, "当前绑定账户:" + _toDisplayString(_ctx.info.name), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dyck && _ctx.dyck(...args)))
        }, "点击抖音授权")
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        (_ctx.icon == 'success')
          ? (_openBlock(), _createElementBlock("img", _hoisted_6))
          : _createCommentVNode("", true),
        (_ctx.icon == 'warn')
          ? (_openBlock(), _createElementBlock("img", _hoisted_7))
          : _createCommentVNode("", true),
        (_ctx.icon == 'error')
          ? (_openBlock(), _createElementBlock("img", _hoisted_8))
          : _createCommentVNode("", true),
        _createElementVNode("p", null, _toDisplayString(_ctx.text), 1)
      ]))
}